import FColumnCellMDP from '../FColumnCellMDP';
export default class FCellCopyMDP implements FColumnCellMDP {
    dataSelectorKeyToCopy?: string;
    tooltipText?: string;
    onClick?: (item: any) => any;
    constructor({
        dataSelectorKey,dataSelectorKeyToCopy,tooltipText,onClick
    }: { dataSelectorKey?: string,dataSelectorKeyToCopy?: string,tooltipText?: string,onClick?: (item: any) => any }) {
        this.dataSelectorKeyToCopy = dataSelectorKeyToCopy;
        this.tooltipText = tooltipText;
        this.onClick = onClick;
    }
    // dataSelectorKey: string;
    componentName: string = "FCellCopy";
    getMetaData(): object {
        return {
            componentName: this.componentName,
            props: {
                onClick: this.onClick,
                dataSelectorKeyToCopy: this.dataSelectorKeyToCopy,
                tooltipText: this.tooltipText
            }
        }
    }

}